const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CommentQuery: any = {
    GetCommentTicketList: `${Backofficebff}/v1/product-comments/ticket-list`,
    GetCommentStatusList: `${Backofficebff}/v1/product-comments/rejectreason-list`,
    GetCommentRejectReasonList: `${Backofficebff}/v1/product-comments/rejectreason-list`,
    GetCustomer: `${Backofficebff}/v1/customer`,
    RejectProductReviews: `${Backofficebff}/v1/product-comments/rejectproductreviews`,
    GetCommentDataV2: `${Backofficebff}/v1/product-comments/list-v2`,
    GetCommentDataByIdV2: `${Backofficebff}/v1/product-comments/single-v2`,
    CommentOperatorListV2: `${Backofficebff}/v1/product-comments/operator-list-v2`,
    RejectPhotoReasonList: `${Backofficebff}/v1/product-comments/photo-reject-reason-list`,
};
